// extracted by mini-css-extract-plugin
module.exports = {"List":"Categories_List__144SM","Categories":"Categories_Categories__2iXSt","ActiveCategory":"Categories_ActiveCategory__1S9lD"};